const GALILEO_COLORS: Record<string, string> = {
  ARAN: '#f18b00',
  ARGE: '#6c746e',
  AZZU: '#c4d8d0',
  BEIG: '#eee1cf',
  BIAN: '#ffffff',
  BLU: '#485ff0',
  BORD: '#7e0d24',
  FUXI: '#c90de6',
  GIAL: '#dddb00',
  GRIG: '#c6c6c6',
  MAGE: '#ff00a6',
  MARR: '#63342c',
  NERO: '#303330',
  ORO: '#c9b04d',
  ROSA: '#d9b9b8',
  ROSS: '#d71313',
  VERD: '#418741',
  VIOL: '#9747ff',
};

export const colorCodeToRgb = (code: string): string => {
  return GALILEO_COLORS[code];
};
